import { DeliveryInformation, Silo } from '@next/core-lib/cart';

import { SkuCatalogItemViewData } from '../product/models/product.models';
import { ValidatableSku } from '../shared/validatable-sku.model';

export interface RepeatOrderItem extends ValidatableSku {
  internalId: number;
  externalId: string;
  latestOrder: string;
  orderUnit: string;
  orderQuantity: number;
  title: string;
  materialType: number;
  silos: Silo[];
  deliveryInformation: DeliveryInformation;
  lastUsedSilos?: Silo[];
}

export interface RepeatOrderItemVM extends RepeatOrderItem {
  isUserAllowedToOrderItem: boolean;
}

export const mapRepeatOrderItemToSkuCatalogItem = (repeatOrderItem: RepeatOrderItem): SkuCatalogItemViewData =>
  ({
    externalSkuId: repeatOrderItem.externalId,
    skuId: repeatOrderItem.internalId,
    quantity: repeatOrderItem.orderQuantity,
    title: repeatOrderItem.title,
    orderingInformation: repeatOrderItem.orderingInformation,
  }) as SkuCatalogItemViewData;
